import { getCustomScreenName } from 'constants/main';
import usePageSlug from './usePageSlug';

const useScreenName = () => {
  const { slug: pathname } = usePageSlug();

  const screenNameFromUrl = pathname.split('/').pop().replace('-', '_');
  const screenName = getCustomScreenName(screenNameFromUrl) || screenNameFromUrl;

  return screenName;
};

export default useScreenName;
